/**
 * src/app/modules/shared/services/url.interceptor.ts
 *
 * @author Bryan Henry <bryan@payfully.co>
 * @date 5/26/2021
 * @copyright Payfully, 2021
 */

import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

@Injectable()
export class UrlInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.url.includes(environment.apiUrlToken)) {
      const dupReq = request.clone({
        url: request.url.replace(environment.apiUrlToken, environment.apiUrl),
      });
      return next.handle(dupReq);
    }
    return next.handle(request);
  }
}
